// extracted by mini-css-extract-plugin
export default {"container":"Main_container__jZ1ug","wrapper":"Main_wrapper__E-hxk","content":"Main_content__vXZtd","center":"Main_center__KQPDy"};